import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function LatestUpdates() {
  const latestMovies = [...movies]
    .sort((a, b) => new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime())
    .slice(0, 8);

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              最新上线
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              实时更新，精彩不错过
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            更多新片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {latestMovies.map((movie, index) => (
            <Link
              key={movie.id}
              to={`/article/${movie.slug}`}
              className="flex items-center gap-4 p-3 rounded-xl hover:bg-background-100 transition-colors duration-200 group cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="w-8 h-8 flex items-center justify-center shrink-0">
                <span className={`text-lg font-heading font-bold ${
                  index < 3 ? 'text-primary-500' : 'text-foreground-400'
                }`}>
                  {String(index + 1).padStart(2, '0')}
                </span>
              </div>

              <div className="w-14 h-14 rounded-lg overflow-hidden shrink-0">
                <img
                  src={movie.image}
                  alt={movie.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {movie.title}
                </h3>
                <div className="flex items-center gap-2 mt-1 text-xs text-foreground-500">
                  <span>{movie.type}</span>
                  <span>·</span>
                  <span>{movie.region}</span>
                  <span>·</span>
                  <span className="text-primary-500 font-medium">{movie.rating}分</span>
                </div>
              </div>

              <div className="hidden sm:block text-xs text-foreground-400 whitespace-nowrap">
                {movie.duration}
              </div>

              <div className="text-xs text-foreground-400 whitespace-nowrap">
                {movie.updateDate}
              </div>

              <div className="w-8 h-8 flex items-center justify-center shrink-0 hidden sm:flex">
                <i className="ri-play-circle-line text-xl text-foreground-300 group-hover:text-primary-500 transition-colors duration-200"></i>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex justify-center mt-8 sm:hidden">
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 font-medium whitespace-nowrap cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            更多新片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}